import {
  motion,
  useScroll,
  useSpring,
  useTransform,
  useVelocity,
  useAnimationFrame,
  useMotionValue,
} from "framer-motion";
import "./scrollVelocity.css";

const wrap = (min, max, v) => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

function ParallaxText({ children, direction = 1 }) {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();

  // On récupère la vitesse brute du scroll
  const scrollVelocity = useVelocity(scrollY);

  // On lisse cette vitesse pour éviter les saccades
  const smoothVelocity = useSpring(scrollVelocity, {
    damping: 50,
    stiffness: 400,
  });

  // On transforme la vitesse en un facteur de mouvement
  // Si smoothVelocity est à 0 (pas de scroll), velocityFactor sera à 0
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
    clamp: false,
  });

  const x = useTransform(baseX, (v) => `${wrap(-20, -45, v)}%`);

  useAnimationFrame((t, delta) => {
    // Le mouvement dépend UNIQUEMENT du velocityFactor (vitesse du scroll)
    // On multiplie par 100 pour donner de l'amplitude au mouvement
    let moveBy = direction * velocityFactor.get() * (delta / 1000) * 5;

    baseX.set(baseX.get() + moveBy);
  });

  return (
    <div className="parallax">
      <motion.div className="scroller" style={{ x }}>
        <span>{children} </span>
        <span>{children} </span>
        <span>{children} </span>
        <span>{children} </span>
      </motion.div>
    </div>
  );
}

export default function ScrollVelocity() {
  return (
    <div className="velocityContainer">
      <ParallaxText direction={1}>
        Fullstack ✦ Motivated ✦ Developer ✦ Creative
      </ParallaxText>
      <ParallaxText direction={-1}>Creative ✦ Design ✦ React ✦</ParallaxText>
    </div>
  );
}
